import { useAuth0, User } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import AuthButtons from '../components/AuthButtons';
import LogoutButton from '../components/LogoutButton';
import Profile from '../components/Profile';

const Home: React.FC = () => {
    const { isAuthenticated, isLoading } = useAuth0<User>();
    const [showMessage, setShowMessage] = useState('');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const shouldReload = urlParams.get('reload');
        const passkeyEnrolled = urlParams.get('passkey_enrolled');

        if (passkeyEnrolled === '1') {
            console.log('Passkey enrollment completed successfully!');
            setShowMessage('passkey_success');

            // Clean URL and reload after showing message
            window.history.replaceState({}, document.title, window.location.pathname);

            setTimeout(() => {
                setShowMessage('');
                window.location.reload();
            }, 3000);

        } else if (shouldReload === '1') {
            console.log('Auth action completed, reloading to refresh auth state...');
            window.history.replaceState({}, document.title, window.location.pathname);
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }
    }, []);

    if (isLoading) {
        return (
            <div className="App">
                <header className="App-header">
                    <h1>TheMousy Web</h1>
                    <div>Loading...</div>
                </header>
            </div>
        );
    }

    // Show passkey success message
    if (showMessage === 'passkey_success') {
        return (
            <div className="App">
                <header className="App-header">
                    <h1>TheMousy Web</h1>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#d4edda',
                        borderRadius: '8px',
                        margin: '20px',
                        border: '1px solid #c3e6cb',
                        color: '#155724'
                    }}>
                        <h2>🎉 Passkey Setup Complete!</h2>
                        <p>Your passkey has been successfully enrolled. You can now use it for future logins.</p>
                        <div style={{ fontSize: '14px', marginTop: '10px' }}>
                            Refreshing in 3 seconds...
                        </div>
                    </div>
                </header>
            </div>
        );
    }

    return (
        <div className="App">
            <header className="App-header">
                <h1>TheMousy Web</h1>

                {isAuthenticated ? (
                    <div>
                        <Profile />
                        <LogoutButton />
                    </div>
                ) : (
                    <AuthButtons />
                )}
            </header>
        </div>
    );
};

export default Home;